import axios from 'axios';
import storage from 'store';
import { message, Modal } from 'ant-design-vue';
import NProgress from 'nprogress'; // 引入nprogress插件
import 'nprogress/nprogress.css'; // 这个nprogress样式必须引入
import router from '@/router/index';
import { sortParams } from '@/utils/sign';
let loadingInstalce = null;
let stepNum = 0; // 请求计步器
axios.defaults.baseURL = import.meta.env.VITE_PHP_BASE_URL; // 配置axios请求的地址
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
axios.defaults.headers['key'] = 'Medcon20201010@)@)@!)';

// 请求拦截器
/**
 * costom 参数
 * {
 *   back : 返回上一页
 *   hideModal ： 是否显示非200弹框
 *   notHeader : 是否去掉请求头信息
 * }
 */
axios.interceptors.request.use(
    async config => {
        let { method, url, costom } = config;

        // 计步器加1
        if (stepNum == 0 && !costom?.hideLoading) {
            // 打开loading
            NProgress.start();
            loadingInstalce && loadingInstalce(0);
        }
        ++stepNum;

        /****************    参数处理    ******************/
        let requestData = method == 'get' ? 'params' : 'data';

        // 防止空对象
        !config.data && (config.data = {});
        !config.params && (config.params = {});

        // 添加时间戳
        config[requestData]['time'] = parseInt(+(new Date() / 1000));

        // 添加签名
        sortParams(config[requestData]) && (config[requestData]['__sign'] = sortParams(config[requestData]));
        // 添加签名

        /****************    请求头处理    ******************/
        const token = storage.get('token');
        token && (config.headers['Authorization'] = `Bearer ${token}`);
        /****************    请求头处理    ******************/
        return config;
    },
    error => {
        return Promise.error(error);
    }
);

axios.interceptors.response.use(
    response => {
        let costom = response?.config?.costom || {};
        // 计步器减一
        --stepNum;
        if (stepNum == 0 && !costom.hideLoading) {
            // 关闭loading
            NProgress.done();
            // 关闭toast
            // loadingInstalce && loadingInstalce(0);
        }
        // 如果返回的状态码为200，说明接口请求成功，可以正常拿到数据
        // 否则的话抛出错误
        // 处理热更新失败问题(不知道为啥，热更新的数据少了一层，可能跟成功后返回的response.data有关)
        if (!response) {
            window.location.reload();
        }
        if (response.status === undefined) {
            response = { status: 200, data: response };
        }

        if (response.status === 200) {
            // 统一处理非200提示
            let { code, message, data } = response.data;
            // hideModal 如果为true则隐藏错误弹框
            if (code != 0) {
                typeof costom.errorCallback == 'function' && costom.errorCallback(response.data);
                if (!costom.hideModal) {
                    if (code == 401) {
                        Modal.error({
                            title: '提示',
                            content: '登录超时，请重新登录',
                            okText: '确定',
                            onOk() {
                                storage.remove('token');
                                router.push(`/login`);
                            }
                        });
                    } else {
                        Modal.error({
                            title: '提示',
                            content: message || '未知问题',
                            okText: '确定',
                            onOk() {
                                costom.back && router.back();
                            }
                        });
                    }
                }
                if (costom.returnSuccessResult) {
                    return Promise.resolve(response.data);
                }
                return Promise.reject(response);
            }
            return Promise.resolve(response.data);
        } else {
            return Promise.reject(data);
        }
    },
    // 服务器状态码不是2开头的的情况
    // 这里可以跟你们的后台开发人员协商好统一的错误状态码
    // 然后根据返回的状态码进行一些操作，例如登录过期提示，错误提示等等
    // 下面列举几个常见的操作，其他需求可自行扩展
    error => {
        console.log(error);
        let costom = error.response?.config?.costom || {};
        // 错误后关闭所有loading
        // 计步器减一
        --stepNum;
        if (stepNum == 0) {
            // 关闭loading
            NProgress.done();
            // 关闭toast
            loadingInstalce && loadingInstalce(0);
        }
        if (error.response && error.response.status) {
            switch (error.response.status) {
                // 401: 未登录
                // 未登录则跳转登录页面，并携带当前页面的路径
                // 在登录成功后返回当前页面，这一步需要在登录页操作。
                case 401:
                    storage.remove('token');
                    router.push(`/login`);
                    if (!costom.hideModal) {
                        // message.error("身份验证失败");
                        // token已过期 此时退出登录
                    }
                    break;

                // 403 token过期
                // 登录过期对用户进行提示
                // 清除本地token和清空vuex中token对象
                // 跳转登录页面
                case 403:
                    // message.error("登录过期，请关闭重新进入。");
                    // token已过期 此时退出登录
                    // let costom = error.response.config.costom || {}
                    //if (!costom.hideModal) {
                    message.error('身份验证失败');
                    // token已过期 此时退出登录
                    //}
                    break;

                // 404请求不存在
                case 404:
                    message.error('您访问的网页不存在。');
                    break;

                // 404请求不存在
                case 500:
                    message.error('数据加载出错');
                    break;
                // 其他错误，直接抛出错误提示
                default:
                    message.error(error.response.data.message);
            }
            return Promise.reject(error.response);
        }
    }
);
export default axios;
